import SiHaDocumentationStatusModelBase from '../_generated/modelBases/si-ha-documentation-status-model-base';

export default class SiHaDocumentationStatusModel extends SiHaDocumentationStatusModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
